<template>
    <div>
        <div v-for="(item, index) in items" :key="index" class="repeater-item">
            <div class="relative"
                 :class="{'blur-2': item.disabled}"
            >
                <div v-if="item.disabled" class="absolute h-full w-full z-10" style="pointer-events: all"></div>
                <div
                    v-for="inputConfig in inputs"
                    :key="inputConfig.key"
                    class="input-group"
                >
                    <dynamic-input
                        :type="inputConfig.type"
                        :label="inputConfig.label"
                        :placeholder="inputConfig.placeholder"
                        :selectOptions="inputConfig.selectOptions"
                        v-model="item[inputConfig.key]"
                    />
                </div>
            </div>
            <div class="grid gap-1">
                <button @click="disableEnableItem(index)" class="bg-gray-100" type="button">{{item.disabled ? 'Aktivieren' : 'Deaktivieren'}}</button>
                <button @click="removeItem(index)" class="bg-red-100" type="button">Löschen</button>
            </div>
        </div>
        <button @click="addItem" type="button">Hinzufügen</button>
    </div>
</template>

<script>
import DynamicInput from "./DynamicInput.vue";

export default {
    components: { DynamicInput },
    props: {
        inputs: {
            type: Array,
            required: true,
        },
        value: { // For v-model compatibility
            type: Array,
            required: true,
        },
    },
    emits: ["input"], // Emit v-model updates
    data(vm) {
        return {
            items: [...vm.value], // Use parent-provided modelValue as initial items
        };
    },
    watch: {
        items: {
            deep: true,
            handler(newItems) {
                this.$emit('input', this.items); // Sync changes with parent
            },
        },
    },
    methods: {
        addItem() {
            // Create a new empty item based on the input keys
            const newItem = this.inputs.reduce((acc, input) => {
                acc[input.key] = input.type === "tags" ? [] : ""; // Default values
                return acc;
            }, {});
            this.items.push(newItem);
        },
        removeItem(index) {
            this.items.splice(index, 1);
        },
        disableEnableItem(index) {
            this.items[index].disabled = !this.items[index].disabled;
        },
    },
};
</script>

<style>
.repeater-item {
    margin-bottom: 1rem;
    padding: 1rem;
    border: 1px solid #ddd;
    border-radius: 5px;
}
.input-group {
    margin-bottom: 0.5rem;
}
</style>